module.exports = __webpack_public_path__ + "assets/img/textur-bg.bcd34736.png";